import { MapSector } from "../../types/mapSector";
import Api from "../api";

export default async function apiGetMapSector(id: string) {
  return await Api.get<MapSector>({
    input: `/api/v1/map-sector/${id}`,
  });
}
